import { Component } from '@angular/core';
import { ReusableGridComponent } from '../../../components/library/reusable-grid/reusable-grid.component';
import { DxSwitchModule } from 'devextreme-angular';
import { DataServiceService } from '../../../services/data-service.service';
import { ActionIDs } from '../../../shared/enums/tables.enum';
import { Router } from '@angular/router';

@Component({
  selector: 'app-merchant-compliance',
  templateUrl: './merchant-compliance.component.html',
  styleUrl: './merchant-compliance.component.scss',
  imports: [ReusableGridComponent, DxSwitchModule], //DxToolbarModule,DxButtonModule,DxSwitchModule
  standalone: true
})
export class MerchantComplianceComponent {
  public ActionIDs = ActionIDs;

  columns = [
    { dataField: 'Id', caption: 'ID', dataType: 'string', hidingPriority: 7, validationRules: [{ type: 'required' }] },
    { dataField: 'CompanyName', caption: 'Merchant', dataType: 'string', hidingPriority: 6, validationRules: [{ type: 'required' }] },
    { dataField: 'Status', caption: 'Status', dataType: 'string', hidingPriority: 5, validationRules: [{ type: 'required' }], lookup: { dataSource: ['Pend', 'New', 'Preparing', 'Dispatched'] } },
    { dataField: 'IsSuperMerchant', caption: 'Type', dataType: 'bool', hidingPriority: 4, validationRules: [{ type: 'required' }] },
    { dataField: 'LastModified', caption: 'Last Update', dataType: 'date', hidingPriority: 3, validationRules: [{ type: 'required' }] },
  ];

  merchantsDataSource: any;

  constructor(dataService: DataServiceService, private router: Router) {
    this.merchantsDataSource = dataService.getMerchantsDataSource();
  }

  toggleUseNavigation() {
    console.log('Toggling use navigation');
    // Add your logic here to toggle navigation or some related functionality
  }

  handleActionClick(actionData: { action: string, data: any }) {
    const { action, data } = actionData;
    console.log(`Action: ${action}, Data:`, data);
    if (action === 'Edit') {
      this.editTask(data);
    } else if (action === 'Delete') {
      this.deleteTask(data);
    }
  }

  editTask(task: any) {
    console.log('Editing task:', task);
    // Implement your edit logic here
  }

  deleteTask(task: any) {
    console.log('Deleting task:', task);
    // Implement your delete logic here
  }

  navigateToDetails(event: any) {
    console.log('1', event);
    this.router.navigate(['/merchant-validation'], { queryParams: { id: event.data.Id } });
    // Add your navigation logic here
    // Example: this.router.navigate(['/details', ]);
  }
  // onSwitchValueChanged($event: ValueChangedEvent) {
  //    console.log('Switch value changed:', $event.value);
  //   }
}
